/**
 * ShareFacebook
 */
import Config from "./Config";

class CopyUrl {
  static init(nodeId) {
    const _nodeId = nodeId ? nodeId : Config.nodeId;
    const _tmp = this.getButton();
    document.querySelector(_nodeId).insertAdjacentHTML("beforeend", _tmp);
    this.addEvent();
  }

  static getButton(className) {
    const _tmp = `<button data-share="url" class="${
      className ? className : `btn__share--url`
    }">
        <i class="icon__url"></i>
        <span>URL Copy</span>
    </button>
    <input value="${
      window.location.href
    }" class="copyurl-input" style="position:absolute;left:-100%;top:-100%;">`;

    return _tmp;
  }

  static copy() {
    const el = document.querySelector(".copyurl-input");
    const lang = {
      ko: {
        copied: "주소가 복사되었습니다. 원하는 곳에 붙여넣기 해주세요."
      },
      en: {
        copied: "URL saved. You can now paste it anywhere you want."
      },
      ja: {
        copied: "アドレスがコピーされました。好きなところに貼り付けできます"
      },
      zh: {
        copied: "已複製連結。請貼至喜歡的地方。"
      }
    };
    const l10n = document.querySelector("html").getAttribute("lang")
      ? document.querySelector("html").getAttribute("lang")
      : "ko";

    // handle iOS as a special case
    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      // save current contentEditable/readOnly status
      let editable = el.contentEditable;
      let readOnly = el.readOnly;

      // convert to editable with readonly to stop iOS keyboard opening
      el.contentEditable = true;
      el.readOnly = true;

      const range = document.createRange();
      range.selectNodeContents(el);

      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      el.setSelectionRange(0, 999999);

      el.contentEditable = editable;
      el.readOnly = readOnly;
    } else {
      el.select();
    }

    document.execCommand("copy");
    alert(lang[l10n].copied);
  }

  static resetValue(_location) {
    document.querySelector(".copyurl-input").value = _location
      ? _location
      : Config.location;
  }

  static addEvent() {
    document.querySelector("[data-share=url]").addEventListener("click", () => {
      this.copy();
    });
  }
}

export default CopyUrl;
